import cx from "classnames";

import Typography from "ds/components/Typography";
import Box from "ds/components/Box";
import { IconComponent } from "types/Icon";
import Icon from "ds/components/Icon";
import { External } from "components/icons/generated";

import styles from "./styles.module.css";

type MainNavigationBaseActionContentProps = {
  title: string;
  icon?: IconComponent;
  className?: string;
  transitionClasses?: string;
  isExternal?: boolean;
};

const MainNavigationBaseActionContent = ({
  title,
  icon,
  className,
  transitionClasses,
  isExternal,
}: MainNavigationBaseActionContentProps) => {
  return (
    <Box align="center" className={styles.baseActionContent} fullWidth>
      {icon && <Icon src={icon} size="default" noShrink />}

      <Box align="center" gap="medium">
        <Typography tag="span" className={cx(styles.text, transitionClasses, className)}>
          {title}
        </Typography>

        {isExternal && <Icon src={External} noShrink />}
      </Box>
    </Box>
  );
};

export default MainNavigationBaseActionContent;
